import { Platform } from 'react-native';

const ANDROID_PACKAGE_ID = 'kingdom.bible.quiz';

const getProductId = (productSuffix: string): string => {
  if (Platform.OS === 'ios') {
    if (productSuffix === 'family.monthly') return 'com.kingdombiblequiz.kingdombiblequiz.family.monthly';
    if (productSuffix === 'family.annual') return 'com.kingdombiblequiz.kingdombiblequiz.family.annual';
  }
  if (Platform.OS === 'android') {
    return `${ANDROID_PACKAGE_ID}.${productSuffix}`;
  }
  return productSuffix;
};

// Current Family Plan subscriptions. iOS must use App Store Connect Product IDs
// (not Apple's numeric subscription IDs); Android keeps the existing Play IDs.
export const REVENUECAT_PRODUCT_IDS = {
  PREMIUM_MONTHLY: getProductId('family.monthly'),
  PREMIUM_ANNUAL: getProductId('family.annual'),
} as const;

export const ALL_PRODUCT_IDS = Object.values(REVENUECAT_PRODUCT_IDS);

export const PRODUCT_IDS_BY_TIER = {
  premium: [
    REVENUECAT_PRODUCT_IDS.PREMIUM_MONTHLY,
    REVENUECAT_PRODUCT_IDS.PREMIUM_ANNUAL,
  ],
} as const;

export const getProductTier = (productId: string): 'premium' => {
  const normalizedId = productId.toLowerCase();
  if (
    normalizedId.includes('family') ||
    normalizedId.includes('individual') ||
    normalizedId.includes('group_') ||
    normalizedId.includes('church_') ||
    normalizedId.includes('premium')
  ) {
    return 'premium';
  }

  return 'premium';
};

export const getBillingInterval = (productId: string): 'monthly' | 'annual' => {
  if (productId === REVENUECAT_PRODUCT_IDS.PREMIUM_ANNUAL) {
    return 'annual';
  }
  if (productId === REVENUECAT_PRODUCT_IDS.PREMIUM_MONTHLY) {
    return 'monthly';
  }
  return productId.toLowerCase().includes('annual') ? 'annual' : 'monthly';
};

export const isValidProductId = (productId: string): boolean => {
  return ALL_PRODUCT_IDS.includes(productId as (typeof ALL_PRODUCT_IDS)[number]);
};

export const logProductIds = () => {
  console.log('🛍️ RevenueCat Product IDs for', Platform.OS);
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  Object.entries(REVENUECAT_PRODUCT_IDS).forEach(([key, value]) => {
    console.log(`${key}: ${value}`);
  });
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
};

export default REVENUECAT_PRODUCT_IDS;
